import type { Db } from "./client";
import { throwIfPgError } from "./errors";
import type {
  GardenEventRow,
  GardenEventSubjectType,
} from "@garden/types/db";

/** garden_event is append-only. Most rows are written by Postgres triggers
 *  (see migration 0007_event_triggers.sql + decisions/0020). The web layer
 *  only reads. */
export async function listEventsForSubject(
  client: Db,
  subjectType: GardenEventSubjectType,
  subjectId: string,
): Promise<GardenEventRow[]> {
  const { data, error } = await client
    .from("garden_event")
    .select("*")
    .eq("subject_type", subjectType)
    .eq("subject_id", subjectId)
    .order("event_date", { ascending: false })
    .order("created_at", { ascending: false });
  throwIfPgError(error);
  return (data ?? []) as GardenEventRow[];
}
